<script>
    import R, {LOADER} from "../lib/requests";
    import {copyObject, formatDate, setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Notifier from "../stores/notifier";

    export let passId = null;
    export let closeCallback;

    let pass = null;
    let isModified = false;
    let cardPassUrl = '';

    const copyCardLink = async () => {
        try {
            await navigator.clipboard.writeText(cardPassUrl);
            Notifier.showMessage("Link copied to clipboard!");
        } catch (err) {
            Notifier.showError("Failed to copy!");
        }
    }

    const initialize = () => {
        const onSuccess = result => {
            pass = result
            setFocusTo('lastname');
        };

        const onFailure = err => {
        };

        if (passId === 0) {
            pass = {
                id: 0,
                hash: '',
                lastname: '',
                firstname: '',
                email: '',
                expire_at: formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1)), 'y-m-d'),
            }
            setFocusTo('lastname');
            return;
        }

        R.handle(R.teatro.details, passId, onSuccess, onFailure, LOADER.POPUP);
    }


    const save = () => {
        const onSuccess = result => {
            pass = result;
            if (passId == 0) {
                Notifier.showMessage("Teatro pass created");
            } else {
                Notifier.showMessage("Teatro pass updated");
            }
            isModified = true;
        }

        const onFailure = err => {
            if (err.message) {
                Notifier.showError(err.message);
                if (err.code == 'user_account_exist') {
                    setFocusTo("passEmail");
                }
            }
        };

        pass.lastname = pass.lastname.trim();
        pass.email = pass.email.trim();
        if (!pass.lastname) {
            Notifier.showError("Type the last name of the member");
            setFocusTo("lastname");
            return;
        }
        // if (!user.email) {
        //     Notifier.showError("Enter the account email");
        //     setFocusTo("userEmail");
        //     return;
        // }

        let action = passId === 0 ? 'create' : 'edit';
        R.handle(R.teatro[action], pass, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = () => {
        let param = copyObject(pass);
        pass = null;

        if (isModified) {
            setTimeout(() => {
                closeCallback(param);
                pass = null;
            }, 200);
            return;
        }

        closeCallback();
    }

    initialize();

    $: {
        if (pass && pass.hash) {
            cardPassUrl = `https://loyalty.enormehotels.com/teatro-card?key=${pass.hash}`;
        }
    }
</script>

{#if pass}
    <Modal title="Teatro Pass" on:close="{ close }">
        <div slot="body">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 form-group">
                    <label>Last name</label>
                    <div class="input-group">
                        <input type="text" class="form-control" id="lastname"
                               bind:value="{ pass.lastname }">
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 form-group">
                    <label>First name</label>
                    <input type="text" class="form-control" bind:value="{ pass.firstname }">
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 form-group">
                    <label>Email</label>
                    <input type="email" id="passEmail" class="form-control" bind:value="{ pass.email }"
                           autocomplete="off">
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 form-group">
                    <label>Teatro Pass until</label>
                    <input type="date" class="form-control" bind:value={pass.expire_at}/>
                </div>
            </div>
            {#if pass.hash}
                <div>Link to Card</div>
                <div class="mb-2">
                    <a href={cardPassUrl} target="_blank">
                        {cardPassUrl}
                    </a>
                </div>
                <button class="btn btn-default btn-sm py-1 px-4" on:click={copyCardLink}>Copy Link</button>
            {/if}
            <hr>
            <div class="text-end">
                <button class="btn btn-link me-4" on:click="{ () => close() }">Close</button>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>
{/if}